require('./dist/select-tpls.js');
module.exports = 'oi.select';


//////////////////
// WEBPACK FOOTER
// ./~/oi.select/index.js
// module id = 451
// module chunks = 3